import { SidebarProps } from "../types";

export const Sidebar = ({ selectedMicroLessons, onRemoveAll }: SidebarProps) => {
  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <p>Selected Micro Lessons</p>
      </div>
      {selectedMicroLessons.map((lesson) => (
        <div className="sidebar-item" key={lesson.lessonId}>
          <div className="sidebar-item-name">{lesson.name}</div>
          <div className="sidebar-item-id">Lesson ID: {lesson.lessonId}</div>
          <div className="sidebar-item-published-date">Published Date: {lesson.publishedDateUtc || "N/A"}</div>
          <div className="sidebar-item-created-date">Tags: {lesson.createdDateUtc || "N/A"}</div>
        </div>
      ))}
      {selectedMicroLessons.length > 0 && (
        <div className="sidebar-footer">
          <button className="primary" onClick={onRemoveAll}>
            Remove All
          </button>
        </div>
      )}
    </div>
  );
};
